export default __webpack_public_path__ + "locales/ar-SA/JavascriptSdk.json?hash=48f94ba2cd3e7163bce96338173034c0";